module.exports = __webpack_public_path__ + "img/noTest.d61128f4.jpg";